/**
 * c-rental-calendar.js
 * BookThatApp iframe 内のカレンダーUIをモックアップデザインに近づける
 *
 * 方式: iframe は srcdoc で同一オリジンのため、
 *       contentDocument に直接 CSS/DOM を注入する。
 *       親ページ側では BTA コンテナにボーダー/パディングを付与する。
 *
 * 注意: BookThatApp の CSS は form[action*="/cart/add"] > * を display:none にするため、
 *       新たな要素をフォーム直下に追加すると非表示になる。
 *       そのため、全てのUI拡張は iframe 内部 or #bta-product-widget 内部で行う。
 */
(function () {
  'use strict';

  /* ========================================
     0. メンバーシップ別 maxDate 算出
     ======================================== */
  var membership = window.__rentalMembership || { plan: '', maxMonths: 3 };
  var MAX_BOOKING_DATE = (function () {
    var d = new Date();
    d.setMonth(d.getMonth() + membership.maxMonths);
    d.setHours(23, 59, 59, 999);
    return d;
  })();

  /* ========================================
     1. iframe 注入用 CSS
     ======================================== */
  var INJECTED_CSS = [
    /* 全体リセット */
    '.main-panel { padding: 0 !important; }',
    '.widget-container { padding: 0 !important; margin: 0 !important; }',
    '.sub-panel.rental-sub-panel { padding: 0 !important; }',

    /* タイトルスタイル */
    '.widget-title.rental-widget-title {',
    '  font-size: 13px !important; font-weight: 600 !important;',
    '  color: #1c1d1d !important; text-align: left !important;',
    '  margin: 0 0 4px !important; padding: 0 !important;',
    '}',

    /* カレンダー */
    '.rdp {',
    '  --rdp-cell-size: 38px !important;',
    '  --rdp-accent-color: #1c1d1d !important;',
    '  --rdp-background-color: #e8e8e8 !important;',
    '  font-family: futura-pt, "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN", sans-serif !important;',
    '  margin: 0 auto !important; width: 100% !important;',
    '}',
    '.rdp-caption { display: flex; align-items: center; justify-content: space-between; padding: 0 0 10px; }',
    '.rdp-caption_label { font-size: 15px !important; font-weight: 600 !important; }',
    '.rdp-nav { display: flex; gap: 6px; }',
    '.rdp-nav_button { width: 28px !important; height: 28px !important; border-radius: 4px !important; }',
    '.rdp-nav_button:hover { background: #f0f0f0 !important; }',
    '.rdp-nav_button[disabled] { opacity: 0.3 !important; }',
    '.rdp-table { width: 100% !important; border-collapse: separate; border-spacing: 2px; }',
    '.rdp-head_cell { font-size: 12px !important; font-weight: 600 !important; color: #999 !important; padding: 4px 0 8px !important; text-transform: none !important; }',
    '.rdp-cell { padding: 0 !important; }',
    '.rdp-day { width: 100% !important; height: 38px !important; font-size: 14px !important; border-radius: 4px !important; border: none !important; transition: background 0.15s !important; }',
    '.rdp-day:not(.rdp-day_disabled):not(.rdp-day_selected):hover { background: #f0f0f0 !important; }',

    /* 無効日 */
    '.rdp-day_disabled { color: #ccc !important; opacity: 1 !important; text-decoration: line-through !important; cursor: default !important; }',

    /* 選択日 */
    '.rdp-day_selected:not(.rdp-day_disabled), .rdp-day_range_start, .rdp-day_range_end {',
    '  background: #1c1d1d !important; color: #fff !important; font-weight: 600 !important; border-radius: 4px !important;',
    '}',
    '.rdp-day_range_middle { background: #e8e8e8 !important; color: #1c1d1d !important; border-radius: 0 !important; }',
    '.rdp-day_today:not(.rdp-day_selected) { font-weight: 700 !important; }',
    '.rdp-day_outside { color: #ccc !important; }',

    /* 土曜(青)・日曜(赤) */
    '.rdp-head_cell:nth-child(7) { color: #1976d2 !important; }',
    '.rdp-head_cell:first-child { color: #d32f2f !important; }',

    /* 入力フィールド・価格（サマリーバーで代替するため非表示） */
    '.rental-widget-label { display: none !important; }',
    'input[type="text"] { display: none !important; }',
    '.price-container { display: none !important; }',

    /* 数量入力: スクロールによる値変更を防止 */
    'input[name="Quantity"] { -moz-appearance: textfield !important; }',
    'input[name="Quantity"]::-webkit-inner-spin-button, input[name="Quantity"]::-webkit-outer-spin-button { -webkit-appearance: none !important; margin: 0 !important; }',

    /* ボタン */
    '.pure-button.fluid {',
    '  background: #1c1d1d !important; color: #fff !important; border: none !important;',
    '  border-radius: 6px !important; font-size: 15px !important; font-weight: 600 !important;',
    '  padding: 14px 20px !important; box-shadow: none !important;',
    '  font-family: futura-pt, "Hiragino Kaku Gothic ProN", sans-serif !important;',
    '  letter-spacing: 0.02em !important; transition: background 0.2s !important;',
    '}',
    '.pure-button.fluid:hover { background: #333 !important; box-shadow: none !important; }',
    '.pure-button.fluid[disabled] { background: #ccc !important; cursor: not-allowed !important; }',

    /* --- 注入UI: 注釈 --- */
    '.c-rental-injected-note { font-size: 11px; color: #999; text-align: right; margin: 0 0 10px; }',

    /* --- 注入UI: 凡例 --- */
    '.c-rental-injected-legend { display: flex; align-items: center; gap: 16px; margin: 12px 0 0; font-size: 11px; color: #999; }',
    '.c-rental-injected-legend > span { display: flex; align-items: center; gap: 5px; }',
    '.c-rental-legend-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; }',
    '.c-rental-legend-dot--selected { background: #1c1d1d; }',
    '.c-rental-legend-dot--booked { background: #ddd; }',

    /* --- 注入UI: サマリーバー --- */
    '.c-rental-injected-summary { display: none; align-items: center; gap: 12px; margin: 14px 0 0; padding: 12px 14px; background: #f8f8f8; border-radius: 4px; font-size: 13px; }',
    '.c-rental-injected-summary.is-visible { display: flex; }',
    '.c-rental-injected-summary .c-label { font-size: 11px; color: #999; margin: 0 0 2px; }',
    '.c-rental-injected-summary .c-value { font-weight: 600; font-family: futura-pt, sans-serif; }',
    '.c-rental-injected-summary .c-arrow { color: #ccc; font-size: 16px; }',
    '.c-rental-injected-summary .c-total { margin-left: auto; text-align: right; }',

    /* --- 注入UI: 保証金カード（Gold パターン / 2026-04-08 改修） --- */
    '.c-rental-deposit-list { display: none; margin: 6px 0 0; padding: 12px 14px; background: #faf5ea; border: 1px solid #eadcb8; border-left: 3px solid #c8a45e; border-radius: 4px; font-size: 12px; }',
    '.c-rental-deposit-list.is-visible { display: block; }',
    '.c-rental-deposit-list .c-head { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; color: #6b4f1a; font-weight: 600; font-size: 12px; }',
    '.c-rental-deposit-list .c-head svg { width: 14px; height: 14px; color: #c8a45e; flex-shrink: 0; }',
    '.c-rental-deposit-list .c-row { display: flex; justify-content: space-between; align-items: baseline; padding: 4px 0; font-size: 13px; color: #1c1d1d; }',
    '.c-rental-deposit-list .c-row .c-amt { font-family: futura-pt, "Inter", sans-serif; font-weight: 600; }',
    '.c-rental-deposit-list .c-note { margin-top: 8px; padding-top: 8px; border-top: 1px solid #eadcb8; font-size: 10px; color: #888; line-height: 1.6; }',

    /* --- 注入UI: お届け予定日 --- */
    '.c-rental-delivery { display: none; margin: 10px 0 0; font-size: 13px; color: #555; }',
    '.c-rental-delivery.is-visible { display: block; }',
    '.c-rental-delivery strong { color: #1c1d1d; font-size: 15px; font-weight: 700; }',

    /* --- メンバーシップ: maxDate 超の日付を無効化 --- */
    '.rdp-day.c-rental-over-max { color: #ccc !important; opacity: 0.4 !important; pointer-events: none !important; cursor: default !important; text-decoration: line-through !important; }',

    /* --- メンバーシップ: 予約可能期間バナー --- */
    '.c-rental-booking-range { font-size: 11px; color: #888; margin: 0 0 8px; padding: 6px 10px; background: #f8f8f8; border-radius: 4px; }',
    '.c-rental-booking-range strong { color: #1c1d1d; font-weight: 600; }'
  ].join('\n');

  /* ========================================
     1.5 メイン価格同期用ユーティリティ
     ======================================== */

  /**
   * cents 単位の JPY 価格をカンマ区切り文字列に変換（例: 1500000 → "15,000"）
   * money_without_currency と一致するフォーマット（小数なし）。
   */
  function formatYen(cents) {
    var yen = Math.round(cents / 100);
    return yen.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * 現在の product id を取得。
   * Impulse の product フォーム (親 document) に <input name="product-id"> が存在する。
   * BTA iframe 内には product-id input は無いため、まず iframe を探し、
   * 無ければ親 document にフォールバックする。
   */
  function getCurrentProductId(doc) {
    var input = (doc && doc.querySelector('input[name="product-id"]')) ||
                document.querySelector('input[name="product-id"]');
    if (!input) return null;
    var v = parseInt(input.value, 10);
    return isNaN(v) ? null : v;
  }

  /**
   * BTA 期間選択タブ群の中から active なボタンを返す。
   * styled-components のハッシュクラスは不安定なので、以下の優先順で判定:
   *   1. aria-pressed="true" / aria-selected="true" があればそれ
   *   2. 位置補助クラス (first/last) を除いた class 文字列が他と異なるボタン
   *      （= active 1個 / inactive 複数 が同一 class hash を共有する前提）
   *   3. どちらも判定不可なら .first（=1泊2日, BTA デフォルト選択）にフォールバック
   * 期間タブが存在しない商品（古い構成）では null を返す。
   */
  function findActivePeriodButton(doc) {
    var first = doc.querySelector('button.first');
    if (!first) return null;
    /* .first とその次兄弟要素（2泊3日, 3泊4日）を取得 */
    var buttons = [];
    var node = first;
    while (node) {
      if (node.tagName === 'BUTTON') buttons.push(node);
      node = node.nextElementSibling;
    }
    /* 1. aria-* で判定 */
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('aria-pressed') === 'true' ||
          buttons[i].getAttribute('aria-selected') === 'true') {
        return buttons[i];
      }
    }

    /* 2. class 比較（位置補助クラスを除いて正規化）
     *    実機例: 1泊2日="sc-feUZmu dUxokQ first", 2泊3日="sc-feUZmu hWpUkU",
     *           3泊4日="sc-feUZmu hWpUkU last"
     *    first/last を除外しないと全ボタンがユニーク化して判定不能になる */
    if (buttons.length >= 2) {
      var normalize = function (b) {
        var parts = (b.className || '').split(/\s+/);
        var keep = [];
        for (var x = 0; x < parts.length; x++) {
          var p = parts[x];
          if (p && p !== 'first' && p !== 'last') keep.push(p);
        }
        return keep.sort().join(' ');
      };
      var normalized = buttons.map(normalize);
      var classCounts = {};
      for (var c = 0; c < normalized.length; c++) {
        classCounts[normalized[c]] = (classCounts[normalized[c]] || 0) + 1;
      }
      var hasDuplicate = false;
      for (var k in classCounts) {
        if (classCounts.hasOwnProperty(k) && classCounts[k] > 1) {
          hasDuplicate = true;
          break;
        }
      }
      if (hasDuplicate) {
        for (var j = 0; j < buttons.length; j++) {
          if (classCounts[normalized[j]] === 1) return buttons[j];
        }
      }
    }

    /* 3. フォールバック: BTA デフォルトは .first */
    return first;
  }

  /**
   * variant.title から該当バリアントを引く。
   * window.__rentalVariants[productId] の配列を線形検索。
   */
  function lookupVariantByTitle(productId, title) {
    var arr = (window.__rentalVariants || {})[productId] || [];
    for (var i = 0; i < arr.length; i++) {
      if ((arr[i].title || '').trim() === (title || '').trim()) return arr[i];
    }
    return null;
  }

  /* ========================================
     2. CSS 注入
     ======================================== */
  function injectCSS(doc) {
    if (doc.getElementById('c-rental-calendar-injected')) return;
    var style = doc.createElement('style');
    style.id = 'c-rental-calendar-injected';
    style.textContent = INJECTED_CSS;
    doc.head.appendChild(style);
  }

  /* ========================================
     3. 安全なDOM要素生成ヘルパー
     ======================================== */
  function createLegendDot(doc, modifier) {
    var dot = doc.createElement('span');
    dot.className = 'c-rental-legend-dot ' + modifier;
    return dot;
  }

  function createLegendItem(doc, dotModifier, labelText) {
    var item = doc.createElement('span');
    item.appendChild(createLegendDot(doc, dotModifier));
    item.appendChild(doc.createTextNode(' ' + labelText));
    return item;
  }

  function createSummaryBlock(doc, labelText, dataAttr) {
    var block = doc.createElement('div');
    var label = doc.createElement('div');
    label.className = 'c-label';
    label.textContent = labelText;
    var value = doc.createElement('div');
    value.className = 'c-value';
    value.setAttribute(dataAttr, '');
    value.textContent = '\u2014'; /* em dash */
    block.appendChild(label);
    block.appendChild(value);
    return block;
  }

  /* ========================================
     4. DOM 注入 (タイトル変更・注釈・凡例・サマリー)
     ======================================== */
  function injectDOM(doc) {
    /* --- タイトル・注釈・凡例（一度だけ） --- */
    if (!doc.getElementById('c-rental-dom-injected')) {
      /* タイトルを「ご利用日を選択」に変更 */
      var title = doc.querySelector('.widget-title');
      if (title) {
        title.classList.add('rental-widget-title');
        title.textContent = 'ご利用日を選択';
        var note = doc.createElement('div');
        note.className = 'c-rental-injected-note';
        note.textContent = '※ ご利用日（レンタル日）は、本日から7日後以降の日程のみご指定いただけます';
        title.parentNode.insertBefore(note, title.nextSibling);
      }

      /* 予約可能期間バナー（メンバーシップ情報あり時のみ） */
      /* PROの12ヶ月特典は廃止（2026-04-07）。BASICのみ表示 */
      // if (membership.plan) {
      //   var rangeText = membership.plan === 'pro' ? 'PROメンバー：12ヶ月先' : 'BASICメンバー：6ヶ月先';
      if (membership.plan === 'basic') {
        var rangeText = 'BASICメンバー：6ヶ月先';
        var rangeNote = doc.createElement('div');
        rangeNote.className = 'c-rental-booking-range';
        var strong = doc.createElement('strong');
        strong.textContent = rangeText;
        rangeNote.appendChild(strong);
        rangeNote.appendChild(doc.createTextNode('まで予約可能'));
        if (title && title.parentNode) {
          var noteEl = title.parentNode.querySelector('.c-rental-injected-note');
          var insertRef = noteEl ? noteEl.nextSibling : title.nextSibling;
          title.parentNode.insertBefore(rangeNote, insertRef);
        }
      }

      /* カレンダー直後に凡例 */
      var rdp = doc.querySelector('.rdp');
      if (rdp && rdp.parentNode) {
        var legend = doc.createElement('div');
        legend.className = 'c-rental-injected-legend';
        legend.appendChild(createLegendItem(doc, 'c-rental-legend-dot--selected', '選択中'));
        legend.appendChild(createLegendItem(doc, 'c-rental-legend-dot--booked', '予約済み'));
        rdp.parentNode.insertBefore(legend, rdp.nextSibling);
      }

      /* 数量入力: type="number" のネイティブ挙動による誤操作を防止
       * - ホイールで値が飛ぶ → wheel イベントをブロック
       * - 上下キーで値が飛ぶ → keydown イベントをブロック
       * ※ ネイティブスピンボタンは CSS で非表示済み
       * ※ BTA カスタム +/- ボタンは React 経由なのでそのまま動作 */
      var qtyInput = doc.querySelector('input[name="Quantity"]');
      if (qtyInput && !qtyInput.hasAttribute('data-c-patched')) {
        qtyInput.setAttribute('data-c-patched', '1');
        qtyInput.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
        qtyInput.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
        });
      }

      /* マーカーを設置（重複注入防止） */
      var marker = doc.createElement('div');
      marker.id = 'c-rental-dom-injected';
      marker.style.display = 'none';
      doc.body.appendChild(marker);
    }

    /* --- サマリーバー（ボタンが遅延描画される場合にも対応） --- */
    if (!doc.getElementById('c-rental-summary')) {
      var btn = doc.querySelector('.pure-button.fluid');
      if (btn && btn.parentNode) {
        var summary = doc.createElement('div');
        summary.className = 'c-rental-injected-summary';
        summary.id = 'c-rental-summary';

        summary.appendChild(createSummaryBlock(doc, '利用開始日', 'data-c-start'));

        var arrow = doc.createElement('span');
        arrow.className = 'c-arrow';
        arrow.textContent = '\u2192'; /* → */
        summary.appendChild(arrow);

        summary.appendChild(createSummaryBlock(doc, '返却予定日', 'data-c-end'));

        var totalBlock = createSummaryBlock(doc, 'レンタル料金', 'data-c-total');
        totalBlock.className = 'c-total';
        summary.appendChild(totalBlock);

        btn.parentNode.insertBefore(summary, btn);
      }
    }

    /* --- デポジット内訳リスト（サマリーバーの直後） --- */
    if (!doc.getElementById('c-rental-deposits')) {
      var summaryForDep = doc.getElementById('c-rental-summary');
      if (summaryForDep) {
        var depList = doc.createElement('div');
        depList.className = 'c-rental-deposit-list';
        depList.id = 'c-rental-deposits';
        summaryForDep.parentNode.insertBefore(depList, summaryForDep.nextSibling);
      }
    }

    /* --- お届け予定日（デポジット内訳の直後） --- */
    if (!doc.getElementById('c-rental-delivery')) {
      var summaryEl = doc.getElementById('c-rental-summary');
      if (summaryEl) {
        var delivery = doc.createElement('div');
        delivery.className = 'c-rental-delivery';
        delivery.id = 'c-rental-delivery';
        var depEl = doc.getElementById('c-rental-deposits');
        var ref = depEl ? depEl.nextSibling : summaryEl.nextSibling;
        summaryEl.parentNode.insertBefore(delivery, ref);
      }
    }
  }

  /* ========================================
     4b. メンバーシップ maxDate 制御
     ======================================== */
  /**
   * rdp カレンダーの日付セルを走査し、MAX_BOOKING_DATE を超える日付に
   * c-rental-over-max クラスを付与して無効化する。
   *
   * react-day-picker は各日付セルに aria-label="MM月DD日 曜日" を付与するが、
   * 年情報がないため、現在表示中の月（rdp-caption_label）から年月を推定する。
   * また、クリックイベントを停止してBTA内部の選択処理もブロックする。
   */
  function enforceMaxDate(doc) {
    /* 現在表示中のキャプション（例: "2026年9月"）から年月を取得 */
    var caption = doc.querySelector('.rdp-caption_label');
    if (!caption) return;
    var captionText = caption.textContent || '';
    var yearMatch = captionText.match(/(\d{4})/);
    var monthMatch = captionText.match(/(\d{1,2})\s*月/);
    if (!yearMatch || !monthMatch) return;

    var displayYear = parseInt(yearMatch[1], 10);
    var displayMonth = parseInt(monthMatch[1], 10) - 1; /* 0-indexed */

    var days = doc.querySelectorAll('.rdp-day:not(.rdp-day_outside)');
    for (var i = 0; i < days.length; i++) {
      var dayEl = days[i];
      var dayNum = parseInt(dayEl.textContent, 10);
      if (isNaN(dayNum)) continue;

      var cellDate = new Date(displayYear, displayMonth, dayNum);
      if (cellDate > MAX_BOOKING_DATE) {
        if (!dayEl.classList.contains('c-rental-over-max')) {
          dayEl.classList.add('c-rental-over-max');
          dayEl.addEventListener('click', blockClick, true);
        }
      } else {
        dayEl.classList.remove('c-rental-over-max');
        dayEl.removeEventListener('click', blockClick, true);
      }
    }

    /* ナビゲーションボタン: 翌月が完全にmaxDate超ならdisabledに
       自分が付けた disabled だけを外せるよう data-* マーカーで区別する
       （BTA 自身がリードタイム等で付けた disabled は壊さない） */
    var nextBtn = doc.querySelector('.rdp-nav_button:last-child');
    if (nextBtn) {
      var nextMonthFirst = new Date(displayYear, displayMonth + 1, 1);
      if (nextMonthFirst > MAX_BOOKING_DATE) {
        nextBtn.setAttribute('disabled', 'disabled');
        nextBtn.dataset.disabledByRentalMax = 'true';
      } else if (nextBtn.dataset.disabledByRentalMax === 'true') {
        nextBtn.removeAttribute('disabled');
        delete nextBtn.dataset.disabledByRentalMax;
      }
    }
  }

  function blockClick(e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.preventDefault();
  }

  /* ========================================
     4c. 初期表示月の自動ジャンプ
     ========================================
     月末などに「今月は全て予約不可で翌月以降からしか選べない」状態だと
     BTA 既定の初期表示が空の今月になり、ユーザーが next を手動で押す必要がある。
     本処理は初回描画時に「予約可能日のある最初の月」へ自動的にナビする。
     最大 MAX_JUMP_ATTEMPTS 回 next を送り、見つからなければ同じ回数だけ
     prev を押して元の月に戻す（=ユーザーが気付かないようロールバック）。
     iframe doc 単位で1回だけ実行（marker: #c-rental-jump-done）。 */

  var MAX_JUMP_ATTEMPTS = 12;

  /** next 月ボタン取得（react-day-picker v8 / 旧版の両方に対応） */
  function findCalendarNextButton(doc) {
    return doc.querySelector('.rdp-nav_button_next') ||
           doc.querySelector('.rdp-nav .rdp-nav_button:last-child') ||
           doc.querySelector('.rdp-nav_button:last-child');
  }

  /** prev 月ボタン取得 */
  function findCalendarPrevButton(doc) {
    return doc.querySelector('.rdp-nav_button_previous') ||
           doc.querySelector('.rdp-nav .rdp-nav_button:first-child') ||
           doc.querySelector('.rdp-nav_button:first-child');
  }

  /**
   * 現在表示中の月に「予約可能な日付」が1個でもあるか判定。
   * 除外する日:
   *   .rdp-day_outside        : 前月末・翌月初の補完日
   *   .rdp-day_disabled       : BTA がブロック（リードタイム / 予約済み）
   *   .c-rental-over-max      : メンバーシップ上限超
   *   aria-disabled="true"    : ARIA レベルの無効化
   *   [disabled]              : ネイティブ disabled
   */
  function hasAvailableDayInCurrentMonth(doc) {
    var days = doc.querySelectorAll('.rdp-day:not(.rdp-day_outside):not(.rdp-day_disabled):not(.c-rental-over-max)');
    for (var i = 0; i < days.length; i++) {
      var day = days[i];
      if (day.getAttribute('aria-disabled') === 'true') continue;
      if (day.hasAttribute('disabled')) continue;
      return true;
    }
    return false;
  }

  function markJumpDone(doc) {
    if (doc.getElementById('c-rental-jump-done')) return;
    var m = doc.createElement('div');
    m.id = 'c-rental-jump-done';
    m.style.display = 'none';
    doc.body.appendChild(m);
    clearJumpInProgress(doc);
    /* ジャンプ完了したらカレンダーiframeをフェードイン表示 */
    setBtaWidgetReady();
  }

  /* CSS の opacity transition と連動して BTA カレンダーを表示する。
     親ページの #bta-product-widget に data-c-rental-ready="true" を立てると
     iframe が opacity 0 → 1 にフェードイン（c-rental-calendar.css 参照） */
  function setBtaWidgetReady() {
    var widget = document.getElementById('bta-product-widget');
    if (widget && widget.getAttribute('data-c-rental-ready') !== 'true') {
      widget.setAttribute('data-c-rental-ready', 'true');
    }
  }

  /* ジャンプ多重起動防止用の in-progress マーカー。
     setInterval(processIframe, 500ms) が動いている間、非同期 step() の
     途中で別サイクルが jumpToFirstAvailableMonth を呼び出すと click が
     並列暴発するため、開始時にマーカーを立て、終了時（done/rollback）に外す */
  function markJumpInProgress(doc) {
    if (doc.getElementById('c-rental-jump-in-progress')) return;
    var m = doc.createElement('div');
    m.id = 'c-rental-jump-in-progress';
    m.style.display = 'none';
    doc.body.appendChild(m);
  }

  function clearJumpInProgress(doc) {
    var m = doc.getElementById('c-rental-jump-in-progress');
    if (m && m.parentNode) m.parentNode.removeChild(m);
  }

  /* リトライクールダウン: rollback 直後の数秒は再ジャンプを抑止。
     BTA がまだ予約データを取得中で「全月 disabled」誤判定したケースを想定し、
     一定時間後に再試行することで「カレンダーちかちか」を防ぎつつ
     データ揃ったタイミングで自動復帰する */
  var JUMP_COOLDOWN_MS = 3000;
  function setJumpCooldown(doc) {
    if (!doc.body) return;
    doc.body.setAttribute('data-c-rental-jump-cooldown-until', String(Date.now() + JUMP_COOLDOWN_MS));
  }

  function isInJumpCooldown(doc) {
    if (!doc.body) return false;
    var until = parseInt(doc.body.getAttribute('data-c-rental-jump-cooldown-until') || '0', 10);
    return Date.now() < until;
  }

  /**
   * BTA が予約データ（リードタイム含む）を非同期取得し終わったかを判定。
   * 今月の表示において「本日より過去のセルが全て disabled」であることを
   * 「BTAデータ反映済み」のシグナルとして利用する。
   *
   * 背景: BTA はロード直後の極初期、過去日にすら disabled クラスが
   * 付いていない瞬間がある（リードタイムAPIレスポンス前）。
   * その瞬間に hasAvailableDayInCurrentMonth を呼ぶと「本日以降が有効」と
   * 誤判定し、markJumpDone で今月（=実は予約不可）に永続ロックされる。
   *
   * 未来月を表示中の場合は過去日が存在せず判定不能なので true を返し、
   * 後段の通常チェックに委ねる（既にジャンプ済みの状態を信頼する）。
   */
  function isBtaDataReady(doc) {
    var caption = doc.querySelector('.rdp-caption_label');
    if (!caption) return false;
    var captionText = caption.textContent || '';
    var yearMatch = captionText.match(/(\d{4})/);
    var monthMatch = captionText.match(/(\d{1,2})\s*月/);
    if (!yearMatch || !monthMatch) return false;

    var displayYear = parseInt(yearMatch[1], 10);
    var displayMonth = parseInt(monthMatch[1], 10) - 1;

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    /* 未来月表示中なら過去日が存在しないので判定不能 → true（=後段に委ねる） */
    if (displayYear !== today.getFullYear() || displayMonth !== today.getMonth()) {
      return true;
    }

    /* 今月表示中: 過去日が1つでも disabled でなければ未反映と判断 */
    var days = doc.querySelectorAll('.rdp-day:not(.rdp-day_outside)');
    for (var i = 0; i < days.length; i++) {
      var day = days[i];
      var dayNum = parseInt(day.textContent, 10);
      if (isNaN(dayNum)) continue;
      var cellDate = new Date(displayYear, displayMonth, dayNum);
      cellDate.setHours(0, 0, 0, 0);
      if (cellDate < today) {
        var isDis = day.classList.contains('rdp-day_disabled') ||
                    day.hasAttribute('disabled') ||
                    day.getAttribute('aria-disabled') === 'true';
        if (!isDis) return false; /* 過去日が有効 = BTAデータ未反映 */
      }
    }
    return true;
  }

  /**
   * 現在の caption テキストが変わるまで待つ（最大 timeoutMs ミリ秒）。
   * React の再描画は同期 setState 後の microtask で走るので 50ms ポーリングで十分。
   */
  function waitForCaptionChange(doc, prevText, timeoutMs, callback) {
    var startedAt = Date.now();
    var iv = setInterval(function () {
      var cur = doc.querySelector('.rdp-caption_label');
      var curText = cur ? cur.textContent : '';
      if (curText !== prevText || Date.now() - startedAt > timeoutMs) {
        clearInterval(iv);
        callback();
      }
    }, 50);
  }

  /** clickCount 回 prev を順次押して元の月に戻す（各クリック後に再描画を待つ） */
  function rollbackJump(doc, clickCount, done) {
    if (clickCount <= 0) { done && done(); return; }
    var prevBtn = findCalendarPrevButton(doc);
    if (!prevBtn || prevBtn.hasAttribute('disabled')) { done && done(); return; }
    var caption = doc.querySelector('.rdp-caption_label');
    var prevText = caption ? caption.textContent : '';
    prevBtn.click();
    waitForCaptionChange(doc, prevText, 500, function () {
      rollbackJump(doc, clickCount - 1, done);
    });
  }

  /**
   * 初期表示月から「予約可能日がある月」を探して next で送る。
   * - すでに今月に予約可能日があれば即終了 → markJumpDone（永続マーカー）
   * - MAX_JUMP_ATTEMPTS 回送っても見つからない／next が disabled に到達した場合は
   *   rollback で元の月に戻し、**markJumpDone は付けずクールダウンに入る**。
   *   これは BTA が予約データを非同期取得中で「全月 disabled」誤判定したケースを
   *   復旧可能にするための仕様（cooldown 経過後に再試行 → BTA データ揃った時点で成功）
   * - in-progress マーカーで二重起動を防止
   */
  function jumpToFirstAvailableMonth(doc) {
    if (doc.getElementById('c-rental-jump-done')) return;
    if (doc.getElementById('c-rental-jump-in-progress')) return;
    if (isInJumpCooldown(doc)) return;

    /* カレンダー本体がまだ描画されていない場合は次の interval にゆずる */
    var captionEl = doc.querySelector('.rdp-caption_label');
    if (!captionEl) return;
    var dayCells = doc.querySelectorAll('.rdp-day:not(.rdp-day_outside)');
    if (dayCells.length === 0) return;

    /* BTA データ反映前は何もしない（誤って markJumpDone するのを防ぐ）。
       過去日が disabled になっていない極初期状態を弾く */
    if (!isBtaDataReady(doc)) return;

    /* 今月に予約可能日があれば即終了 */
    if (hasAvailableDayInCurrentMonth(doc)) {
      markJumpDone(doc);
      return;
    }

    markJumpInProgress(doc);

    var clicksMade = 0;
    var giveUp = function () {
      rollbackJump(doc, clicksMade, function () {
        clearJumpInProgress(doc);
        setJumpCooldown(doc);
      });
    };
    var step = function () {
      if (clicksMade >= MAX_JUMP_ATTEMPTS) { giveUp(); return; }
      var nextBtn = findCalendarNextButton(doc);
      if (!nextBtn || nextBtn.hasAttribute('disabled')) { giveUp(); return; }
      var prevText = (doc.querySelector('.rdp-caption_label') || {}).textContent || '';
      nextBtn.click();
      clicksMade++;
      waitForCaptionChange(doc, prevText, 500, function () {
        /* 新しい月のセルに over-max クラスを再適用してから判定 */
        enforceMaxDate(doc);
        if (hasAvailableDayInCurrentMonth(doc)) {
          markJumpDone(doc);
        } else {
          step();
        }
      });
    };
    step();
  }

  /* ========================================
     5. サマリーバー同期
     ======================================== */
  var DAY_NAMES = ['日', '月', '火', '水', '木', '金', '土'];

  /**
   * BookThatApp の日付文字列をパースする
   * 形式例: "03/31(火)", "2025/03/31", "03/31" など
   */
  function parseBTADate(str) {
    if (!str) return null;
    var cleaned = str.replace(/\(.*?\)/g, '').trim();
    var parts = cleaned.split('/');
    if (parts.length === 3) {
      return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    }
    if (parts.length === 2) {
      var now = new Date();
      var m = parseInt(parts[0], 10) - 1;
      var d = parseInt(parts[1], 10);
      var year = now.getFullYear();
      if (m < now.getMonth()) year++;
      return new Date(year, m, d);
    }
    return null;
  }

  function formatDeliveryDate(date) {
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var day = DAY_NAMES[date.getDay()];
    return m + '\u6708' + d + '\u65E5(' + day + ')';
  }

  function updateDeliveryText(deliveryEl, doc, dateStr) {
    while (deliveryEl.firstChild) deliveryEl.removeChild(deliveryEl.firstChild);
    deliveryEl.appendChild(doc.createTextNode('\u3054\u5229\u7528\u65E5\u524D\u65E5\u306E'));
    var strong = doc.createElement('strong');
    strong.textContent = dateStr;
    deliveryEl.appendChild(strong);
    deliveryEl.appendChild(doc.createTextNode('\u306B\u304A\u5C4A\u3051'));
  }

  /**
   * BTAが`.price-container`に追加するデポジット系ラベルの日本語化マップ
   * 管理画面で英語ラベルを設定している場合のみ変換する。日本語は素通し。
   */
  /* デポジット項目は2026-04-08廃止。Bond系のみ「保証金」として表示。
   * Deposit ラベルが残っている場合も「保証金」に統一する */
  var DEPOSIT_LABEL_MAP = {
    'Security Bond': '保証金',
    'Bond': '保証金',
    'Deposit': '保証金'
  };

  function localizeDepositLabel(label) {
    var clean = (label || '').replace(/[\s\-：:]+$/, '').trim();
    /* BTAで％設定の場合「60% Security Bond」のように接頭辞が付くため剥がす */
    var stripped = clean.replace(/^\d+%\s*/, '').trim();
    return DEPOSIT_LABEL_MAP[stripped] || DEPOSIT_LABEL_MAP[clean] || stripped;
  }

  /**
   * `.price-container` を構造的にパースして
   *   - rentalPrice: レンタル料金（.ml10 の値）
   *   - deposits: [{label, amount}, ...] デポジット系の追加料金行
   * を返す。
   *
   * BTAが出力する構造例:
   *   <p class="price-container">
   *     <span><span>Deposit - </span><span>¥10,000</span></span>
   *     <span><span>Security Bond - </span><span>¥10,000</span></span>
   *     <span>価格:</span>
   *     <span class="ml10 ...">¥1,500</span>
   *   </p>
   */
  function parsePriceContainer(priceEl) {
    var result = { rentalPrice: '', deposits: [] };
    if (!priceEl) return result;

    /* レンタル料金本体: .ml10 */
    var priceSpan = priceEl.querySelector('.ml10');
    if (priceSpan) result.rentalPrice = priceSpan.textContent.trim();

    /* デポジット行: 直接子の <span> のうち、子に「ラベル + 金額」の2spanを持つもの */
    var children = priceEl.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child.tagName !== 'SPAN') continue;
      if (child.classList && child.classList.contains('ml10')) continue;
      if (child.children.length !== 2) continue;
      var labelEl = child.children[0];
      var amountEl = child.children[1];
      if (!labelEl || !amountEl) continue;
      var amount = amountEl.textContent.trim();
      if (!/[¥$€£]?\s*[\d,]+/.test(amount)) continue;
      result.deposits.push({
        label: localizeDepositLabel(labelEl.textContent),
        amount: amount
      });
    }
    return result;
  }

  function renderDepositList(doc, depList, deposits) {
    while (depList.firstChild) depList.removeChild(depList.firstChild);
    /* 「保証金」ラベルのみ抽出（デポジット項目は廃止 / 2026-04-08） */
    var bondDeposits = deposits.filter(function (d) {
      return d.label === '保証金';
    });
    if (!bondDeposits.length) {
      depList.classList.remove('is-visible');
      return;
    }

    /* ヘッダー（金アイコン + 「返却後に全額返金されます」） */
    var head = doc.createElement('div');
    head.className = 'c-head';
    /* SVG: 返却を示す circular arrow（インラインSVG） */
    var SVG_NS = 'http://www.w3.org/2000/svg';
    var svg = doc.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var path1 = doc.createElementNS(SVG_NS, 'polyline');
    path1.setAttribute('points', '23 4 23 10 17 10');
    var path2 = doc.createElementNS(SVG_NS, 'path');
    path2.setAttribute('d', 'M20.49 15a9 9 0 1 1-2.12-9.36L23 10');
    svg.appendChild(path1);
    svg.appendChild(path2);
    head.appendChild(svg);
    head.appendChild(doc.createTextNode('返却後に全額返金されます'));
    depList.appendChild(head);

    /* 金額行 */
    bondDeposits.forEach(function (d) {
      var row = doc.createElement('div');
      row.className = 'c-row';
      var label = doc.createElement('span');
      label.textContent = d.label;
      var amt = doc.createElement('span');
      amt.className = 'c-amt';
      amt.textContent = d.amount;
      row.appendChild(label);
      row.appendChild(amt);
      depList.appendChild(row);
    });

    /* 注記文（破損・汚損時の減額/追加請求を含む） */
    var note = doc.createElement('div');
    note.className = 'c-note';
    note.textContent = 'ご返却・検品後、ご決済時のカードへ自動返金されます。通常使用の範疇を超える過度な破損・汚損や延滞があった場合は返金額の減額または追加請求となる場合があります。';
    depList.appendChild(note);
    depList.classList.add('is-visible');
  }

  /* ========================================
     5.5 親ページのメイン価格を BTA 選択に追従させる
     ======================================== */

  /**
   * iframe 内の以下を観測して、親ページの .c-rental-price を更新する:
   *   - active な期間ボタン（1泊2日 / 2泊3日 / 3泊4日）→ variant.price
   *   - input[name="Quantity"] の値 → 単価 × 個数
   *
   * 取得不能・マッチ無しなら何もしない（=Liquid 初期表示のまま）。
   */
  function syncMainPrice(doc) {
    var priceRoots = document.querySelectorAll('.c-rental-price');
    if (!priceRoots.length) return;

    var pid = getCurrentProductId(doc);
    if (!pid) return;

    var activeBtn = findActivePeriodButton(doc);
    if (!activeBtn) return;

    var title = (activeBtn.textContent || '').trim();
    var variant = lookupVariantByTitle(pid, title);
    if (!variant) return;

    var qtyInput = doc.querySelector('input[name="Quantity"]');
    var qty = 1;
    if (qtyInput) {
      var n = parseInt(qtyInput.value, 10);
      if (!isNaN(n) && n >= 1) qty = n;
    }

    var unitPrice = variant.price; /* cents */
    var totalPrice = unitPrice * qty;
    var amountText = formatYen(totalPrice);
    var unitText = qty > 1 ? '/ ' + title + ' × ' + qty : '/ ' + title;

    for (var i = 0; i < priceRoots.length; i++) {
      var amountEl = priceRoots[i].querySelector('[data-c-price-amount]');
      var unitEl = priceRoots[i].querySelector('[data-c-price-unit]');
      if (amountEl) amountEl.textContent = amountText;
      if (unitEl) unitEl.textContent = unitText;
    }

    /* Quantity input が再描画された場合に備えて冪等に input イベントを bind */
    if (qtyInput && !qtyInput.hasAttribute('data-c-price-bound')) {
      qtyInput.setAttribute('data-c-price-bound', '1');
      qtyInput.addEventListener('input', function () { syncMainPrice(doc); });
    }
  }

  function syncSummary(doc) {
    var summary = doc.getElementById('c-rental-summary');
    if (!summary) return;

    var inputs = doc.querySelectorAll('input[type="text"]');
    var startVal = inputs[0] ? inputs[0].value : '';
    var endVal = inputs[1] ? inputs[1].value : '';
    var priceEl = doc.querySelector('.price-container');
    var deliveryEl = doc.getElementById('c-rental-delivery');
    var depList = doc.getElementById('c-rental-deposits');

    if (startVal && endVal) {
      var startEl = summary.querySelector('[data-c-start]');
      var endEl = summary.querySelector('[data-c-end]');
      var totalEl = summary.querySelector('[data-c-total]');
      if (startEl) startEl.textContent = startVal;
      if (endEl) endEl.textContent = endVal;

      var parsed = parsePriceContainer(priceEl);
      if (totalEl) {
        totalEl.textContent = parsed.rentalPrice || '\u2014';
      }
      if (depList) renderDepositList(doc, depList, parsed.deposits);

      summary.classList.add('is-visible');

      /* お届け予定日: 利用開始日の1日前 */
      if (deliveryEl) {
        var startDate = parseBTADate(startVal);
        if (startDate) {
          var deliveryDate = new Date(startDate);
          deliveryDate.setDate(deliveryDate.getDate() - 1);
          updateDeliveryText(deliveryEl, doc, formatDeliveryDate(deliveryDate));
          deliveryEl.classList.add('is-visible');
        }
      }
    } else {
      summary.classList.remove('is-visible');
      if (deliveryEl) deliveryEl.classList.remove('is-visible');
      if (depList) depList.classList.remove('is-visible');
    }
  }

  /* ========================================
     6. 親ページ側のコンテナスタイル
     ======================================== */
  function styleParentContainer() {
    var btaWidget = document.getElementById('bta-product-widget');
    if (!btaWidget) return;

    var btaContainer = btaWidget.querySelector('#bta-widget-container') || btaWidget;
    if (btaContainer.getAttribute('data-c-styled')) return;
    btaContainer.style.cssText = 'border: 1px solid #e0e0e0; border-radius: 6px; padding: 16px; background: #fff;';
    btaContainer.setAttribute('data-c-styled', '1');

    /* iframe コンテナの高さを auto に */
    var xComponent = btaWidget.querySelector('[id*="widget-xcomponent"]');
    if (xComponent) xComponent.style.height = 'auto';
  }

  /* ========================================
     7. メイン処理
     ======================================== */
  function processIframe() {
    var btaWidget = document.getElementById('bta-product-widget');
    if (!btaWidget) return;

    var iframe = btaWidget.querySelector('iframe');
    if (!iframe) return;

    try {
      var doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
      if (!doc || !doc.body) return;

      injectCSS(doc);
      injectDOM(doc);
      enforceMaxDate(doc);
      jumpToFirstAvailableMonth(doc); /* 初期表示月を最初の予約可能月へ */
      syncSummary(doc);
      syncMainPrice(doc);          /* ← この1行を追加 */
      styleParentContainer();
    } catch (e) {
      /* cross-origin の場合は無視 */
    }
  }

  /* ========================================
     8. 起動
     ======================================== */
  function init() {
    /* BTA ウィジェットは遅延読み込みのため、繰り返し試行。
       BTAデータ取得が遅延する環境（モバイル/低速回線）でも初期ジャンプを
       完了できるよう試行時間を確保する */
    var attempts = 0;
    var maxAttempts = 60; /* 最大30秒 */
    var timer = setInterval(function () {
      attempts++;
      processIframe();
      if (attempts >= maxAttempts) clearInterval(timer);
    }, 500);

    /* フォールバック: ジャンプが完走しない異常系（BTAが永久に予約データを返さない等）に
       備え、ロード後 8 秒経過したら強制的に iframe を表示する。
       これがないと最悪「カレンダーが永遠に見えない」事故になる */
    setTimeout(setBtaWidgetReady, 8000);

    /* サマリー同期用の定期実行（日付変更検知） */
    setInterval(function () {
      var btaWidget = document.getElementById('bta-product-widget');
      if (!btaWidget) return;
      var iframe = btaWidget.querySelector('iframe');
      if (!iframe) return;
      try {
        var doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
        if (doc) {
          injectCSS(doc); /* Reactの再レンダリングに備えて再注入 */
          injectDOM(doc);
          enforceMaxDate(doc);
          jumpToFirstAvailableMonth(doc); /* marker 付与済みなら no-op */
          syncSummary(doc);
          syncMainPrice(doc);      /* ← この1行を追加 */
          /* React再レンダリングで data-c-patched が消える場合に備えて再パッチ */
          var qi = doc.querySelector('input[name="Quantity"]');
          if (qi && !qi.hasAttribute('data-c-patched')) {
            qi.setAttribute('data-c-patched', '1');
            qi.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
            qi.addEventListener('keydown', function (e) {
              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
            });
          }
        }
      } catch (e) { /* ignore */ }
    }, 2000);
  }

  /* MutationObserver で BTA ウィジェットの出現を監視 */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType === 1 &&
            (node.id === 'bta-product-widget' ||
             (node.querySelector && node.querySelector('#bta-product-widget')))) {
          setTimeout(processIframe, 500);
        }
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
      init();
    });
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
    init();
  }
})();
